import { useEffect, useState } from 'react';
import {
  AgxBodyText,
  AgxControlledCheckbox,
  AgxRow,
} from '@urbanx/agx-ui-components';

interface ComplimentaryItemProps {
  id: string;
  productName: string;
  selected: boolean;
  onSelectProductChange: (value: {
    id: string;
    productName: string;
    pricePerUnit?: number;
    value: boolean;
  }) => void;
}

const ComplimentaryItem = ({
  id,
  productName,
  selected,
  onSelectProductChange,
}: ComplimentaryItemProps) => {
  const [productSelected, setProductSelected] = useState(selected);

  useEffect(() => {
    setProductSelected(selected === true);
  }, [selected]);

  useEffect(() => {
    onSelectProductChange({
      id,
      productName,
      pricePerUnit: undefined,
      value: productSelected,
    });
  }, [productSelected]);

  const onValueChanged = (value: boolean) => {
    setProductSelected(value === true);
  };

  return (
    <AgxRow
      fill
      spaceBetween
      centered
      mediumGap
      extraClasses="marketingPackageItem"
    >
      <AgxControlledCheckbox
        naked
        label={productName}
        checked={productSelected}
        onValueChanged={onValueChanged}
        id={id}
      />
      <AgxBodyText small>Complimentary</AgxBodyText>
    </AgxRow>
  );
};

export default ComplimentaryItem;
